module.exports = __webpack_public_path__ + "img/collect-empty.d093a32f.png";